/* stanta.js · „ștanța”, comportamentul butoanelor casei (28.09.2026)
   Încărcat pe ambele layouturi, theme.liquid și password.liquid. Stilul stă în variables.css.
   Două treburi:
   1. pe iPhone, :active (presarea) se aprinde doar dacă pagina ascultă atingerea;
   2. după click, urma presării rămâne pe buton până se încarcă pagina următoare, dar DOAR
      când click-ul chiar pleacă de pe pagină: link spre altă pagină sau formular valid.
      Pe butoanele care nu schimbă pagina (cookie-uri, cantitate) și pe formularele cu câmpuri
      goale, butonul doar se apasă cât îl ții; o urmă rămasă acolo ar minți că s-a întâmplat ceva.
*/
(function () {
  'use strict';

  document.addEventListener('touchstart', function () {}, { passive: true });

  function pleacaDePePagina(b, e) {
    if (b.tagName === 'A') {
      var href = b.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || /^javascript:/i.test(href)) return false;
      if ((b.target && b.target !== '_self') || b.hasAttribute('download')) return false;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return false;
      var u = new URL(b.href, location.href);
      // doar o ancoră pe aceeași pagină nu pleacă nicăieri
      return !(u.origin === location.origin && u.pathname === location.pathname && u.search === location.search);
    }
    if (b.type === 'submit' && b.form) {
      return b.form.noValidate || b.formNoValidate || b.form.checkValidity();
    }
    return false;
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.btn');
    if (!b || !pleacaDePePagina(b, e)) return;
    // pusă pe loc, în același pas cu clickul, ca presarea să nu clipească între :active și urmă
    b.classList.add('is-imprimat');
    setTimeout(function () {
      // alt script a oprit plecarea: ștanța se ridică
      if (e.defaultPrevented) b.classList.remove('is-imprimat');
    }, 0);
    // plasă: dacă după 10 secunde pagina e tot aici, navigarea n-a pornit
    setTimeout(function () { b.classList.remove('is-imprimat'); }, 10000);
  });

  // butonul Înapoi aduce pagina din cache, cu tot cu urmă: ștanța se ridică
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('.btn.is-imprimat').forEach(function (b) {
      b.classList.remove('is-imprimat');
    });
  });
})();
